import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import logoImg from "@/assets/logo.png";
const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const navItems = [{
    path: "/",
    label: "HOME"
  }, {
    path: "/about",
    label: "ABOUT US"
  }, {
    path: "/contact",
    label: "CONTACT"
  }, {
    path: "/rooms",
    label: "ROOMS"
  }, {
    path: "/dining",
    label: "DINING"
  }, {
    path: "/events",
    label: "EVENTS"
  }, {
    path: "/more",
    label: "MORE INFO"
  }];
  const isActive = (path: string) => location.pathname === path;
  return <nav className="bg-background/95 backdrop-blur-md border-b border-border sticky top-0 z-50 shadow-soft">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <img src={logoImg} alt="Kijani Arusha Airport Lodge" className="h-14 w-auto object-contain" />
            <div className="hidden sm:block">
              <h1 className="font-heading text-xl text-foreground font-bold">Arusha Airport Lodge</h1>
            </div>
          </Link>

          {/* Desktop Navigation - Better responsive breakpoint */}
          <div className="hidden xl:flex items-center space-x-6">
            {navItems.map(item => <Link key={item.path} to={item.path} className={`text-sm font-medium transition-colors hover:text-primary whitespace-nowrap ${isActive(item.path) ? "text-primary border-b-2 border-primary pb-1" : "text-muted-foreground"}`}>
                {item.label}
              </Link>)}
            <Button variant="default" asChild className="bg-primary hover:bg-primary/90 text-primary-foreground shadow-soft whitespace-nowrap">
              <Link to="/book">BOOK YOUR STAY</Link>
            </Button>
          </div>

          {/* Mobile menu button */}
          <div className="xl:hidden">
            <Button variant="ghost" size="icon" onClick={() => setIsOpen(!isOpen)} className="text-foreground" aria-label={isOpen ? "Close navigation menu" : "Open navigation menu"} aria-expanded={isOpen}>
              {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </Button>
          </div>
        </div>

        {/* Mobile Navigation with backdrop blur */}
        {isOpen && <>
            <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-40 xl:hidden" onClick={() => setIsOpen(false)} />
            <div className="xl:hidden border-t border-border bg-background/95 backdrop-blur-md relative z-50">
              <div className="px-2 pt-2 pb-3 space-y-1">
                {navItems.map(item => <Link key={item.path} to={item.path} className={`block px-3 py-2 text-base font-medium transition-colors ${isActive(item.path) ? "text-primary bg-primary/10" : "text-muted-foreground hover:text-primary hover:bg-primary/5"}`} onClick={() => setIsOpen(false)}>
                    {item.label}
                  </Link>)}
                <div className="px-3 py-2">
                  <Button variant="default" asChild className="w-full bg-primary hover:bg-primary/90 text-primary-foreground">
                    <Link to="/book" onClick={() => setIsOpen(false)}>
                      BOOK YOUR STAY
                    </Link>
                  </Button>
                </div>
              </div>
            </div>
          </>}
      </div>
    </nav>;
};
export default Navigation;